import React, { useEffect, useState } from "react";
import CommonList from "../crud/CommonList";
import { apiCallResponse } from "src/_apiConfig/apiCall";
import Auth from "../../auth";
import { defaultCommonSearchModel } from "../common/commonSearchModel";
import { CommonSearch, updateSearchStatus } from "../common/CommonSearch";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import {
  FilterContains,
  FilterContainsInsensitive,
  FilterEqual,
} from "../common/FilterCondition";

const TransferToHoLotRequestList = () => {
  const { authenticated } = Auth();
  const [usersData, setuserData] = useState();
  const [loading, setloading] = useState(false);
  const [pageLimit, setpageLimit] = useState(0);
  const [disabledprev, setdisabledprev] = useState(false);
  const [disablednext, setdisablednext] = useState(false);
  const [textField, settextField] = useState("transferFromUser");
  const [order, setorder] = useState("asc");
  const [orderClick, setOrderClick] = useState(true);
  const [itemPerPage, setItemPerPage] = useState(10);

  const [search, setSearch] = useState(defaultCommonSearchModel);
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage

  // useEffect(() => {
  //   orderClick ? setorder("asc") : setorder("desc");
  //   getTransferLotList(true);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageLimit, textField, orderClick, itemPerPage, authenticated]);

  useEffect(() => {
    paggingDisabled();
    setloading(true);
    reset();
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getTransferLotList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getTransferLotList(true);
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const reset = () => {
    setpageLimit(0);
  };
  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Manage
  const paggingDisabledManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";

    filter = "&$filter=";

    if (authenticated.role === "DFO") {
      filter += "districtId eq " + authenticated.district;
      // +
      // " and isUserApproved eq true and payment ne null";
    }
    if (authenticated.role === "CFO") {
      filter += "circleId eq " + authenticated.district;
      // +
      // " and isUserApproved eq true and payment ne null";
    }
    filter = FilterContains(
      filter,
      "collectionSeason",
      search.collectionSeason
    );
    filter = FilterEqual(filter, "tenderNo", search.tenderNo);
    if (search.companyName !== "" && search.companyName !== undefined) {
      if (filter !== "&$filter=") {
        filter += " and ";
      }
      filter += "(contains(transferFromUser,'" + search.companyName + "')";
      filter += "or contains(transferToUser,'" + search.companyName + "'))";
    }

    filter = FilterContainsInsensitive(filter, "lotNo", search.lotNo);

    // if (search.emailAddress !== "" && search.emailAddress !== undefined) {
    //   if (filter !== "&$filter=") {
    //     filter += " and ";
    //   }
    //   filter +=
    //     "(contains(tolower(transferFromUser),'" +
    //     search.emailAddress +
    //     "') or contains(toupper(transferFromUser),'" +
    //     search.emailAddress +
    //     "'))";
    // }

    // if (search.lotNo !== "" && search.lotNo !== undefined) {
    //   if (filter !== "&$filter=") {
    //     filter += " and ";
    //   }
    //   filter +=
    //     "(contains(tolower(lotNo),'" +
    //     search.lotNo +
    //     "') or contains(toupper(lotNo),'" +
    //     search.lotNo +
    //     "'))";
    // }

    // if (
    //   search.collectionSeason !== "" &&
    //   search.collectionSeason !== undefined
    // ) {
    //   if (filter !== "&$filter=") {
    //     filter += " and ";
    //   }
    //   filter += "contains(collectionSeason,'" + search.collectionSeason + "')";
    // }
    // if (search.tenderNo !== "" && search.tenderNo !== undefined) {
    //   if (filter !== "&$filter=") {
    //     filter += " and ";
    //   }
    //   filter += " tenderNo eq '" + search.tenderNo + "'";
    // }

    if (filter === "&$filter=") {
      filter = "";
    }

    return filter;
  };

  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(`LotTransfer/GetForHO?${filterManage()}`).then(
        (res) => {
          if (res.success)
            paggingDisabledManage(parseInt(res.data.length) || 0);
        }
      );
    }
  };
  const getTransferLotList = async () => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);
      await apiCallResponse(
        `LotTransfer/GetForHO?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filterManage()}`
      )
        .then((res) => {
          if (res.success) {
            setuserData(res.data);
            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingDisabledManage(pageCount);
            }
          }
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };

  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };

  // Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...defaultCommonSearchModel });
    setuserData();
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    setpageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    setpageLimit(pageLimitSet);
  };

  //table header Click manage
  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    reset();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  const fields = [
    {
      key: "transferFromUser",
      _style: { width: "15%" },
      label: TableHeaderSet("Transferor", "transferFromUser"),
    },
    {
      key: "transferToUser",
      label: TableHeaderSet("Transferee", "transferToUser"),
    },
    {
      key: "tenderNo",
      label: TableHeaderSet("Tender Number", "tenderNo"),
    },
    {
      key: "lotNo",
      label: TableHeaderSet("Lot Number", "lotNo"),
    },
    {
      key: "quantity",
      label: TableHeaderSet("Quantity", "quantity"),
    },
    {
      key: "purchaseRate",
      label: TableHeaderSet("Purchase Rate", "purchaseRate"),
    },
    {
      key: "purchasePrice",
      label: TableHeaderSet("Purchase Price", "purchasePrice"),
    },
    {
      key: "requestDateTime",
      label: TableHeaderSet("Request Date", "requestDateTime"),
    },
    {
      key: "requestUpdateDateTime",
      label: TableHeaderSet("Request Update Date", "requestUpdateDateTime"),
    },
    // {
    //   key: "TransferStatus",
    //   label: TableHeaderSet("Status", "status"),
    // },

    // {
    //   key: "isRefertoHo",
    //   label: "IsRefertoHo",
    // },
    {
      key: "show_details",
      label: "View",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "viewTransferLetter",
      label: "View Transfer Letter",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];
  let additional = (
    <>
      <CommonSearch
        isDisabledSearchClear={loading}
        isClear={isClear}
        search={search}
        updateSearch={updateSearch}
        searchButton={searchButton}
        clearSearch={clearSearch}
        itemPerPage={itemPerPage}
        onChangePage={onChangePage}
        isEmailAddressDisplay={false}
        isCompanyNameDisplay={true}
        CompanyNameLabel={"Transferor/Transferee Name : "}
        //extraControl={SearchExtraControl}
        isLotNumberDisplay={true}
      />
    </>
  );
  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Lot Transfer Approval"
      loading={loading}
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      tabBtn="View"
      path="/transferlotapprovalviewho/"
      id="lotTransferId"
    />
  );
};

export default TransferToHoLotRequestList;
